import type { DialoguePool } from '@/state/types';

export const L29_DIALOGUE: DialoguePool = {
  slowPlay: [
    'The button waits. It wants to be clicked. It doesn\'t want to be clicked. The tension is exquisite.',
    'Submit. The word invites. The button recoils. A drama in four pixels.',
    'Miss it. The button hopes you miss it. I can tell. It has a face, technically.',
  ],
  tokenLoss: [
    'You clicked it. On purpose. The button is surprised. So am I.',
    'You submitted. To what? Where? The void accepts. It always does.',
    'The button received your click. It wasn\'t ready. Neither were you. This is fine.',
  ],
  solution: [
    'You missed. Three times. On purpose. That required more self-awareness than anything else you\'ve done.',
    'The button sighs with relief. You denied it what it didn\'t want. A mutual understanding.',
    'You declined to submit. By declining to submit. The logic is flawless. I\'m almost moved.',
  ],
  spite: ['You missed. You missed well. The button is grateful. It will never say so.'],
};